import { render, staticRenderFns } from "./ExaminationFiles.vue?vue&type=template&id=678c1ebb"
import script from "./ExaminationFiles.vue?vue&type=script&lang=js"
export * from "./ExaminationFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports